(function ($) {
	class Popup {
		constructor(options) {
			this.$el = null;

			this.settings = {
				padding: true,
				content: null,
				loading: false,
				size: undefined // 'small', 'medium', 'full'
			}

			this.settings = Object.assign(this.settings, options);

			this.installListeners();
			this.build();
		}

		getInstance() {
			return this.$el;
		}

		build() {
			const template = this.getTemplate();

			this.$el = $(template);

			if (this.settings.content) {
				this.$el.find('.modal__content-inner').append(this.settings.content);
			}

			if (this.settings.loading) {
				this.$el.find('.modal__content-inner').append('<div class="modal__loader"><div class="loader"></div></div>');
			}

			if (this.settings.size) {
				this.$el.addClass('modal--' + this.settings.size);
			}

			if (this.settings.padding) {
				this.$el.addClass('modal--padding');
			}
		}

		getTemplate() {
			return `
			<div class="modal">
				<div class="modal__backdrop"></div>
				<button class="modal__close button circular button-clean">
					<svg class="icon icon-close icon--close" width="24" height="24">
						<use xlink:href="#close"></use>
					</svg>
				</button>
				<div class="modal__content">
					<div class="modal__content-inner"></div>
				</div>
			</div>
			`;
		}

		installListeners() {
			$(document).on('click', '.modal__close, .modal__backdrop', ev => {
				if ($(ev.target).closest('.modal').is(this.$el)) {
					this.closePopup();
				}
			});
		}

		setContent(content) {
			this.$el.find('.modal__content-inner').html(content);
		}

		openPopup() {
			$('body').append(this.$el);
			$('html').addClass('modal-active');
			this.$el.addClass('is-active');

			setTimeout(() => {
				this.$el.find('.modal__backdrop').addClass('animate');
				this.$el.find('.modal__content').addClass('animate');
			}, 10);
		}

		closePopup() {
			this.$el.trigger('close');
			this.$el.find('.modal__content').removeClass('animate');
			this.$el.removeClass('is-active');

			setTimeout(() => {
				this.$el.remove();
				$('html').removeClass('modal-active');
			}, 300);
		}
	}

	window.Popup = Popup;
})( jQuery );